import { styled } from '@mui/material/styles'

export const VisuallyHidden = styled('span')({
	position: 'absolute',
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: 'hidden',
	clip: 'rect(0,0,0,0)',
	whiteSpace: 'nowrap',
	border: 0,
})

// Block-level equivalent for aria-live regions. Screen readers require a div
// (not a span) to reliably detect dynamic content changes on NVDA + Chrome/Firefox.
export const AnnouncementSrOnly = styled('div')({
	position: 'absolute',
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: 'hidden',
	clip: 'rect(0,0,0,0)',
	whiteSpace: 'nowrap',
	border: 0,
})
